import React from 'react';

import { Messages } from '../../../codegen/Localize';
import { BrowserTitleService } from '../../../commonInfra/services/BrowserTitleService';
import { SpaceContainerStyles } from '../../../style/SpaceContainerStyles';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { ConnectedExplorer } from '../Explorer/ConnectedExplorer';
import { ExplorerStyles } from '../Explorer/ExplorerStyles';
import { ButtonWidget, ButtonType } from '@tableau/widgets';
import { sendCreateCollectionClickedTelemetry, CreateCollectionClickedSourceOptions } from './CollectionsTelemetry';
import { CollectionDefinition } from '../../../ts/models/contentDefinitions/CollectionDefinition';


export interface AllCollectionsSpaceOwnProps extends ReactDirectiveProps {}

export interface AllCollectionsSpaceStateProps {
  readonly isBusyFetchingItems: boolean;
  readonly numberOfFetchedCollections: number;
}

export interface AllCollectionsSpaceDispatchProps {
  readonly requestSpaceContents: () => void;
  readonly createNoNameCollection: () => void;
}

export type AllCollectionsSpaceProps = AllCollectionsSpaceOwnProps & AllCollectionsSpaceStateProps & AllCollectionsSpaceDispatchProps;

export class AllCollectionsSpace extends React.PureComponent<AllCollectionsSpaceProps> {
  public componentDidMount() {
    BrowserTitleService.setTitleWithPlaceEntityName({ placeEntityName: Messages.collections() });
    this.props.requestSpaceContents();
  }

  public render(): JSX.Element {
    return(
      <div className={ SpaceContainerStyles.SpaceContainer }>
        <div className={SpaceContainerStyles.MastheadArea}>
          <div className={ExplorerStyles.SpaceHeaderContent}>
            <div className={ExplorerStyles.SpaceHeaderText}>{Messages.collectionsSpaceLabel()}</div>
          </div>
        </div>
        <div className={ SpaceContainerStyles.SubplaceArea }>
          <ConnectedExplorer
            angularContext={this.props.angularContext}
            supportedDisplayModes={CollectionDefinition.supportedDisplayModes}
            toolbarProps={{
              supportFilterPanel: true,
              toolbarVisibility: 'enabled',
              toolbarContentSpecificControls: { beginning: this.createNewCollectionButton() }
            }}
            emptyStateProps={{
              primaryMessage: Messages.collectionsEmptyMessage()
            }}
          />
        </div>
      </div>
    );
  }

  private createNewCollectionButton = (): JSX.Element => {
    return (<ButtonWidget
      handleClick={() => {
        sendCreateCollectionClickedTelemetry('collections', CreateCollectionClickedSourceOptions.NewCollectionButton);
        this.props.createNoNameCollection();
      }}
      children={Messages.createCollectionButtonLabel()}
      buttonType={ButtonType.Outline}
      testId={'new-collection-button'}
      />);
  }
}
